import routerOptions0 from "/home/runner/work/ss-bonsai-admin-frontend/ss-bonsai-admin-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}